import React, { useEffect } from "react"
import { TextFieldSeeker } from "@ui-seeker/core"
import { useValidatorSeeker } from "@ui-seeker/app"
import { object, string } from "yup"
import useAutoEuropeDataInfo from "Pages/AutoEuropeTool/Page/@hooks/useDataInfo"
import { autoEuropeDrawerData, autoEuropeDrawerErrors } from "Pages/AutoEuropeTool/Page/@signals"

export default function AutoEuropeName() {
	const { dataInfo, setDataInfo } = useAutoEuropeDataInfo(autoEuropeDrawerData.peek().name || null)

	const { errors, isValid } = useValidatorSeeker({ name: dataInfo.value }, object({
		name: string()
			.required("Name is required")
			.min(5, "Name must be at least 5 characters long")
			.max(100, "Name can be at most 100 characters long")
	}))

	useEffect(() => {
		autoEuropeDrawerErrors.value = { ...autoEuropeDrawerErrors.value, name: isValid }
	}, [JSON.stringify(errors)])

	return <TextFieldSeeker
		label="Name"
		value={dataInfo.value || ""}
		onChange={e => setDataInfo(e.target.value, "name")}
		error={errors?.name}
	/>
}
